import React from 'react';
import './Spacing.css';

const Spacing = ({ 
  children, 
  size = 'medium',
  direction = 'all',
  className = '',
  ...props 
}) => {
  const sizeClasses = {
    none: 'spacing-none',
    small: 'spacing-small',
    medium: 'spacing-medium',
    large: 'spacing-large',
    xl: 'spacing-xl'
  };

  const directionClasses = {
    all: 'spacing-all',
    top: 'spacing-top',
    bottom: 'spacing-bottom',
    left: 'spacing-left',
    right: 'spacing-right',
    horizontal: 'spacing-horizontal',
    vertical: 'spacing-vertical'
  };

  const classes = [
    sizeClasses[size],
    directionClasses[direction],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Spacing;
